import HttpService from './http-service';
import EdudoResponse from '../models/edudo-response';

export default class ChatService {
  async listChatSummary(): Promise<ChatSummary[]> {
    const response = await HttpService.getJson<EdudoResponse<ChatSummary[]>>(
      '/v1/chats/summary'
    );

    return response.data;
  }


  async getChatDetail(chatId: string): Promise<ChatDetail> {
    const response = await HttpService.getJson<EdudoResponse<ChatDetail>>(
      `/v1/chats/${chatId}/detail`
    );

    return response.data;
  }

  async sendChatMessage(chatId: string, text: string): Promise<ChatMessage> {
    const body = { text: text };
    var response = await HttpService.postJson<EdudoResponse<ChatMessage>>(`/v1/chats/${chatId}/send`, body);

    return response.data;
  }

  async receiveUnreadMessages(chatId: string, lastMessageId: string = null): Promise<ChatMessage[]> {
    const body = { lastMessageId: lastMessageId };
    const response = await HttpService
      .postJson<EdudoResponse<ChatMessage[]>>(`/v1/chats/${chatId}/receiveUnreadMessages`, body);

    return response.data;
  }
}
